import request from '@/utilsCloud/request'
import port from './port'

// 查询课程详情
export function getUserCourseStudyDetail(query) {
  return request({
    url: port.course + '/home/getUserCourseStudyDetail',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

export function getUserCourseStudyDetailFromSingleCourse(query) {
  return request({
    url: port.course + '/home/getUserCourseStudyDetailFromSingleCourse',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 课程练习列表
export function courseExerciseList(query) {
  return request({
    url: port.exam + '/exercise/courseExerciseList',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 为你推荐
export function getStudyreCommendList(query) {
  return request({
    url: port.course + '/home/getStudyreCommendList',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 获取学员查看的下一个课节
export function getTheNextStudyCourse(query) {
  return request({
    url: port.course + '/home/getTheNextStudyCourse',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 个人信息-个人信息详情
export function getEmployeeInformation(query) {
  return request({
    url: port.biz + '/employee/getEmployeeInformation',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 获取配置
export function getEntpCourseConfigCurrent(data) {
  return request({
    url: port.course + '/courseConfig/getEntpCourseConfigCurrent',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}

export function getStudyccCountToday(data) {
  return request({
    url: port.course + '/home/getStudyccCountToday',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}


export function getEntpExerciseConfigCurrent(data) {
  return request({
    url: port.exam + '/exerciseConfig/getEntpExerciseConfigCurrent',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}

export function getEmployeeCourseOverStatus(data) {
  return request({
    url: port.stat + '/statisticsAnalysis/getEmployeeCourseOverStatus',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}

export function getEmployeeExerciseCountByExerciseId(query) {
  return request({
    url: port.exam + '/exercise/getEmployeeExerciseCountByExerciseId',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

export function getActive(query) {
  return request({
    url: port.course + '/activationCodeEmp/active',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    data: query
  })
}

export function exerciseDetailVerification(data) {
  return request({
    url: port.exam + '/exercise/exerciseDetailVerification',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: data
  })
}


// 看课权限认证
export function getUserCourseStudyConfig(query) {
  return request({
    url: port.course + '/home/getUserCourseStudyConfig',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/apiCloud/courseDetail.js